/**
 * @flow
 * @relayHash 77606942212e54f62885aa8a831dd31e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UserEditInput = {
  userId?: ?string,
  name?: ?string,
  email?: ?string,
  active?: ?boolean,
  canDelete?: ?boolean,
  blocked?: ?boolean,
  testText?: ?string,
};
export type UserEditMutationVariables = {|
  input: UserEditInput
|};
export type UserEditMutationResponse = {|
  +UserEdit: ?{|
    +error: ?string,
    +user: ?{|
      +id: string,
      +name: ?string,
    |},
  |}
|};
export type UserEditMutation = {|
  variables: UserEditMutationVariables,
  response: UserEditMutationResponse,
|};
*/


/*
mutation UserEditMutation(
  $input: UserEditInput!
) {
  UserEdit(input: $input) {
    error
    user {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UserEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "UserEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UserEditInput!"
      }
    ],
    "concreteType": "UserEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "UserEditMutation",
  "id": null,
  "text": "mutation UserEditMutation(\n  $input: UserEditInput!\n) {\n  UserEdit(input: $input) {\n    error\n    user {\n      id\n      name\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UserEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "UserEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6b8f37c31089f5097a7f533bea5c4d70';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/UserEditMutation.graphql.js